import {HomeTabPage} from './type';
import {getClientStore, IReduxState} from '../../common/store';
import {
  ISendEventParam,
  ISendViewImpParam,
  sendEvent,
  sendViewImp,
} from '../../common/util/tracking';
import {TimeTableSecondTab} from '../timeTable/type';

export const TRACKING_HOME_SECTION: {[key in HomeTabPage]: string} = {
  [HomeTabPage.Ranking]: 'ranking',
  [HomeTabPage.MyPage]: 'library',
  [HomeTabPage.TimeTable]: 'timetable',
};
export const TRACKING_HOME_PAGE: {[key in HomeTabPage]: string} = {
  [HomeTabPage.Ranking]: 'top',
  [HomeTabPage.MyPage]: 'library',
  [HomeTabPage.TimeTable]: 'timetable',
};

export function getHomeActionName(tabPage: HomeTabPage, secondTab: string) {
  switch (tabPage) {
    case HomeTabPage.Ranking: {
      return getRankingTrackingName(secondTab).replace('top_', '');
    }
    case HomeTabPage.MyPage: {
      return secondTab === 'recent'
        ? 'recent'
        : secondTab === 'own'
          ? 'purchased'
          : 'favorite';
    }
    case HomeTabPage.TimeTable: {
      return getTimetableAction(secondTab as TimeTableSecondTab);
    }
  }
}

function getTimetableAction(tab: TimeTableSecondTab) {
  return tab === 'new' ? 'new' : tab === 'complete' ? 'end' : tab;
}

export function sendHomeEvent(
  params: Pick<ISendEventParam, 'actionName' | 'action' | 'customProps'> & {
    page?: string;
  }
) {
  const state = getClientStore()?.getState();
  if (!state) return;

  sendEvent({
    ...getSectionAndPage(state),
    ...params,
  });
}

export function sendHomeViewImp(
  params: Pick<ISendViewImpParam, 'customProps' | 'viewImpContents'> & {
    page?: string;
  }
) {
  const state = getClientStore()?.getState();
  if (!state) return;

  sendViewImp({
    ...getSectionAndPage(state),
    ...params,
  });
}

export function getSectionAndPage(state: IReduxState) {
  const tabPage = state.home.tabPage;
  const secondTab = state.home.secondTabs[tabPage].selected;

  const section = TRACKING_HOME_SECTION[tabPage];
  const actionName = getHomeActionName(tabPage, secondTab);
  const page = `${TRACKING_HOME_PAGE[tabPage]}_${actionName}`;

  return {
    section,
    page,
  };
}

export function getHomeSubTabId(tabPage: HomeTabPage, secondTab: string) {
  switch (tabPage) {
    case HomeTabPage.Ranking: {
      return getRankingTrackingName(secondTab);
    }
    case HomeTabPage.MyPage: {
      return secondTab === 'recent'
        ? 'history_recent_read'
        : secondTab === 'own'
          ? 'history_purchased_content'
          : 'history_like_content';
    }
    case HomeTabPage.TimeTable:
      return `timetable_${getTimeTableSubTabId(
        secondTab as TimeTableSecondTab
      )}`;
  }
}
function getTimeTableSubTabId(tab: TimeTableSecondTab) {
  return tab === 'complete' ? 'completed' : tab;
}

const getRankingTrackingName = (id: string) => {
  return (
    getClientStore()
      ?.getState()
      .ranking.ranking.tabs.find(tab => tab.id === id)?.placement || `top_${id}`
  );
};
